angular.module('SpidApp')

.directive('clearInput', ['$timeout', function($timeout){
    return { 
    	priority: 0,
    	restrict: 'A',
    	scope: {
    		datamodel:    '=',
    		defaultvalue: '=',
    		change:       '&'
    	},
    	template: '<span class="input-clear glyphicon glyphicon-remove-circle" ng-click="clearInput()"></span>',
    	controller: function($scope) {
    		$scope.clearInput = function() {
    			var newValue = '';
    			if ($scope.defaultvalue || $scope.defaultvalue === 0) {
    				newValue = $scope.defaultvalue;
    			}
    			
    			$scope.datamodel = newValue;
    			$timeout(function() {
    				$scope.change();
    			}, 75);
    		}
    	}
	};  
}]);